<template>
  <div style="padding:5px"  class="row">
    <div class="col-lg-3 col-md-6 col-sm-12 mb-3">
        <label for="per-page" class="form-label me-2 mt-2">Per page</label>
        <select id="per-page" class="form-control" v-model="perPage" @change="currentPage = 1; getTopChannels()">
          <option :value="10">10</option>
          <option :value="20">20</option>
          <option :value="50">50</option>
        </select>
    </div>
    <div class="col-lg-3 col-md-6 col-sm-12  mb-3">
      <label for="category" class="form-label me-2 mt-2">Content category</label>
      <select class="form-control" id="category" v-model="category" @change="getTopChannels()">
        <option :value="null">All</option>
        <option v-for="contentCategory in contentCategories" :value="contentCategory.id">
          {{contentCategory.name}}
        </option>
      </select>
    </div>
    <div class="col-lg-3 col-md-6 col-sm-12 mb-3">
      <label for="type" class="form-label me-2 mt-2">Type</label>
      <select id="type" class="form-control" v-model="type" @change="getTopChannels()">
        <option :value="0">MRR</option>
        <option :value="1">One time-tips</option>
        <option :value="2">Subscriptions</option>
        <option :value="3">Pay per-post</option>
        <option :value="4">Fundraiser</option>
        <option :value="5">Merchant e-shop</option>
        <option :value="7">Pay per-category</option>
        <option :value="8">Pay per-content subscription</option>
        <option :value="9">Subscription upgrade</option>
      </select>
    </div>
    <div class="col-lg-3 col-md-6 col-sm-12 mb-3">
      <label for="currency" class="form-label me-2 mt-2">Currency</label>
      <select class="form-control" id="currency" v-model="selectedCurrency" @change="getTopChannels()">
        <option :value="null">All</option>
        <option v-for="currency in currencies" :value="currency.currency">{{currency.currency}}</option>
      </select>
    </div>

  </div>

  <div style="padding:5px" class="row">
    <div class="col-lg-3 col-md-6 col-sm-12 mb-3">
      <button :disabled="disableExport" @click="exportTopChannels()" type="button" class="btn btn-success text-white">
          <span v-if="!disableExport">Export CSV</span>
          <span v-else><font-awesome-icon icon="fa-solid fa-sync" spin/></span>
      </button>
    </div>
  </div>

  <div class="table-responsive">
    <table class="table">
      <thead>
      <tr>
        <th scope="col">Place</th>
        <th scope="col">Id</th>
        <th scope="col">Creator name, slug</th>
        <th scope="col">Amount</th>
        <th scope="col">Active subscribers count</th>
        <th scope="col">Actions</th>
      </tr>
      </thead>
      <tbody>

      <tr v-if="loading">
        <td colspan="7" class="text-center"><font-awesome-icon icon="fa-solid fa-sync" spin/></td>
      </tr>
      <tr v-else-if="channels.length > 0" v-for="(channel, index) in channels" :class="{
        'first-place': currentPage === 1 && index === 0,
        'second-place': currentPage === 1 && index === 1,
        'third-place': currentPage === 1 && index === 2}">
        <td>{{index + 1}}</td>
        <td>{{channel.id}}</td>
        <td>
          <p>{{channel.name}}</p>
          <a :href="channel.link">{{channel.slug}}</a>
        </td>
        <td>{{ Math.floor(channel.total_amount * 100) / 100 }} {{channel.currency}}</td>
        <td>{{channel.total_active_subscribers}}</td>
        <td>
          <div class="btn-group-sm d-flex gap-3" role="group">
            <router-link :to="{name: 'SingleChannel', params: {id: channel.id}}" class="btn btn-info">View</router-link>
          </div>
        </td>
      </tr>
      <tr v-else>
        <td colspan="7" class="text-center">No creators</td>
      </tr>
      </tbody>
    </table>
    <div class="d-flex justify-content-between" v-if="totalRecords >= 1">
      <div>
        <div class="p-2">
          <p>Total creators: {{ totalRecords }}</p>
        </div>
      </div>
      <div>
        <div class="p-2">
          <nav v-if="totalPages >= 1" aria-label="Page navigation example">
            <ul class="pagination">
              <li class="page-item" :class="{disabled: currentPage - 1 < 1}">
                <a @click="paginate(currentPage - 1)" class="page-link">Previous</a>
              </li>
              <li class="page-item cursor-pointer" :class="{active: 1 === currentPage}">
                <a @click="paginate(1)" class="page-link" :class="{'not-clickable': currentPage === 1}">1</a>
              </li>
              <li class="page-item cursor-pointer" v-if="currentPage - 2 > 1">
                <span class="page-link">...</span>
              </li>
              <li class="page-item cursor-pointer" v-if="currentPage - 2 > 1">
                <a @click="paginate(currentPage - 2)" class="page-link">{{ currentPage - 2}}</a>
              </li>
              <li class="page-item cursor-pointer" v-if="currentPage - 1 > 1">
                <a @click="paginate(currentPage - 1)" class="page-link">{{ currentPage - 1}}</a>
              </li>
              <li class="page-item cursor-pointer" v-if="currentPage !== 1"  :class="{active: currentPage}">
                <a @click="paginate(currentPage)" class="page-link" :class="{'not-clickable': currentPage}">{{currentPage }}</a>
              </li>
              <li class="page-item cursor-pointer" v-if="currentPage + 1 <= totalPages">
                <a @click="paginate(currentPage + 1)" class="page-link">{{ currentPage + 1}}</a>
              </li>
              <li class="page-item cursor-pointer" v-if="currentPage + 2 <= totalPages">
                <a @click="paginate(currentPage + 2)" class="page-link">{{ currentPage + 2}}</a>
              </li>
              <li class="page-item cursor-pointer" v-if="currentPage + 2 < totalPages">
                <span class="page-link">...</span>
              </li>
              <li class="page-item cursor-pointer" v-if="currentPage !== totalPages && currentPage + 2 < totalPages" :class="{active: totalPages === currentPage}">
                <a @click="paginate(totalPages)" class="page-link" :class="{'not-clickable': totalPages === currentPage}">{{totalPages }}</a>
              </li>
              <li class="page-item" :class="{disabled: currentPage + 1 > totalPages}">
                <a @click="paginate(currentPage + 1)" class="page-link">Next</a>
              </li>
            </ul>
          </nav>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import axios from 'axios';
import _debounce from "lodash/debounce";

export default {
  data() {
    return {
      loading: true,
      channels: [],
      currencies: [],
      contentCategories: [],
      selectedCurrency: 'EUR',
      category: null,
      type: 0,
      currentPage: 1,
      totalPages: 0,
      totalRecords: 0,
      perPage: 20,
      disableExport: false,
    }
  },

  mounted() {
    this.getTopChannels();
    this.fetchCurrencies();
    this.fetchContentCategories();
  },

  methods: {
    getFilterParams() {
      const payload = {
        type: this.type,
        category: this.category,
        currency: this.selectedCurrency,
      };
      return Object.fromEntries(
        Object.entries(payload).filter(([, v]) => v != null)
      );
    },
    debounceGetTopChannels: _debounce(function () {
      this.loading = true;
      const { currentPage, perPage } = this;
      const params = {
        page: currentPage,
        per_page: perPage,
        ...this.getFilterParams(),
      };
      axios.get('/admin/top-channels', { params })
          .then(response => {
        this.channels = response.data.data;
        this.totalPages = response.data.totalPages;
        this.totalRecords = response.data.totalRecords;
        this.loading = false;
      })
          .catch(error => {
            this.loading = false;
            console.log(error);
          });
    }, 500),
    getTopChannels() {
      this.loading = true;
      this.debounceGetTopChannels();
    },

    exportTopChannels() {
        this.disableExport = true;
        const params = this.getFilterParams();
        axios.get('/admin/export/top-channels', { params, responseType: 'blob' })
        .then(response => {

          const blob = new Blob([response.data], { type: 'text/csv' });
          const now = new Date();

          const readableTime = now.toISOString().replace(/[:.]/g, '_').replace('T', '_').split('Z')[0];
          const uniqueFileName = `top_creators_${readableTime}.csv`;

          const link = document.createElement('a');

          link.href = URL.createObjectURL(blob);
          link.download = uniqueFileName;
          link.click();

          URL.revokeObjectURL(link.href);
          this.disableExport = false;
          this.$toast.success('Top creators exported to CSV');
        })
        .catch(error => {
          console.error('Error downloading file:', error);
          this.disableExport = false;
          this.$toast.error('Failed to export CSV. Please try again later.');
        });
    },


    fetchContentCategories() {
      axios.get(`/admin/content-categories`)
          .then(response => {
            this.contentCategories = response.data.data;
          })
          .catch(error => {
            console.log(error);
          });
    },
    fetchCurrencies() {
      axios.get(`/admin/currency/channels`)
          .then(response => {
            this.currencies = response.data.data;
          })
          .catch(error => {
            console.log(error);
          });
    },
    paginate(page) {
      this.currentPage = page;
      this.getTopChannels();
    }
  }
}
</script>
